import { FaroButton, FaroText } from "@faro-lotv/flat-ui";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import type { JSX } from "react";

type DevToolsTableProps = {
  isResetting: boolean;
  onResetFueFlags(): void;
  searchText: string;
};

/** @returns Developer-only actions for experimental features. */
export function DevToolsTable({
  isResetting,
  onResetFueFlags,
  searchText,
}: DevToolsTableProps): JSX.Element {
  const normalizedSearchText = searchText.toLowerCase();
  const showResetFueFlags = [
    "reset feature tour flags",
    "reset the feature tour flags for the current user.",
  ].some((text) => text.includes(normalizedSearchText));

  return (
    <Table sx={{ width: "100%" }}>
      <TableHead>
        <TableRow>
          <TableCell sx={{ p: 1 }}>
            <FaroText variant="helpText">Action</FaroText>
          </TableCell>
          <TableCell sx={{ p: 1 }}>
            <FaroText variant="helpText">Description</FaroText>
          </TableCell>
          <TableCell sx={{ p: 1 }} />
        </TableRow>
      </TableHead>
      <TableBody>
        {showResetFueFlags && (
          <TableRow>
            <TableCell sx={{ p: 1 }}>
              <FaroText variant="heading12">Reset feature tour flags</FaroText>
            </TableCell>
            <TableCell sx={{ p: 1 }}>
              <FaroText variant="helpText">
                Reset the feature tour flags for the current user.
              </FaroText>
            </TableCell>
            <TableCell align="right" sx={{ p: 1 }}>
              <FaroButton
                size="s"
                disabled={isResetting}
                onClick={onResetFueFlags}
              >
                {isResetting ? "Resetting..." : "Reset"}
              </FaroButton>
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
}
